import './App.css';

export function App() {
  return (
    <>
      <h1>Coming Soon!</h1>
    </>
  );
}
